import { React, useState, useEffect } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import SideBar from "../../Components/SideBar";
import { useParams, Link } from "react-router-dom";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";

export default function Fixture({ params }) {
  let ballerzToken = BallerzToken();

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const [goal, setGoal] = useState("");
  const [keyLoop, setKeyLoop] = useState(0);

  const { fixtureID } = useParams();

  let text = fixtureID;
  let result = text.replace("%40", "@");

  const { status, data } = useGetRequest(`fixtures/list?id=${result}`, {});

  useEffect(() => {
    if (data.status == "success") {
      setGoal(data?.fixtures[0]?.goals[0]?.url);
    }
  }, [data]);

  if (status === "fetched") {
    return (
      <div>
        <div className="DashboardTemplate">
          <div
            data-testid="PortalTwoColumnPageLayout"
            className="PortalTwoColumnPageLayout flex min-h-screen flex-col"
          >
            <Header />

            <div
              data-testid="TwoColumnPageLayout"
              className="TwoColumnPageLayout max-w-[100vw] flex-1 bg-[#0F0F0F]"
            >
              <div
                data-testid="SectionContainer"
                className="SectionContainer mx-auto px-[10px] pb-[60px] pt-[20px] md:px-[20px] lg:px-[20px] xl:pt-0  min-h-screen max-w-[1440px]"
              >
                <div className="flex flex-col pb-0 md:flex-row lg:pt-[70px]">
                  <SideBar usernames="Unknown"/>

                  <div className="flex flex-col">
                    <h2 className="text-white text-xl font-bold DrukWide ml-7">
                      GAME SCORE
                    </h2>

                    {/* <div className="relative flex flex-row-reverse justify-between items-center sm:w-4/5 md:w-2/3 ml-5 p-5 mt-4"> */}
                    <div className="relative flex flex-row-reverse justify-between items-center mt-4 sm:w-4/5 md:w-2/3 md:ml-5 md:p-5 ">
                      <img
                        src={require("../../Assets/Images/score-blue-background.png")}
                        className="absolute w-full h-full top-0 left-0 object-cover bg-transparent rounded-xl"
                      />

                      <span
                        className="flex flx-row justify-center items-center w-full DrukWide p-4"
                        style={{ mixBlendMode: "multiply" }}
                      >
                        {data?.fixtures[0]?.home?.name}

                        <span
                          className="flex flx-row justify-center items-center w-full DrukWide p-4 text-3xl"
                          style={{ mixBlendMode: "multiply" }}
                        >
                          {data?.fixtures[0]?.home?.score}-{" "}
                          {data?.fixtures[0]?.away?.score}
                        </span>

                        {data?.fixtures[0]?.away?.name}
                      </span>
                    </div>

                    <div className="flex flex-row flex-wrap">
                      <div
                        className={`text-white max-w-4xl mx-auto bg-[#0F0F0F]`}
                      >
                        <div className="w-full mt-4 ml-4 relative">
                          {goal && (
                            <>
                              {/* <iframe
                                className="w-full aspect-video"
                                src={goal}
                                allowFullScreen
                              /> */}

                              <video
                                key={goal}
                                className="w-full aspect-video"
                                controls
                                loop
                                muted
                              >
                                <source src={goal} key={goal} type="video/mp4" />
                              </video>

                              <div className="absolute top-0 right-0 ">
                                <button
                                  onClick={() => alert(goal)}
                                  className="bg-gray-500 text-white px-3 py-3 rounded-md shadow-md mt-2"
                                >
                                  <img
                                    className="h-[25px] w-[25px]"
                                    src={require("../../Assets/Images/download-video.png")}
                                    alt="logo"
                                  ></img>
                                </button>
                                <button
                                  onClick={() => alert(goal)}
                                  className="ml-2 bg-gray-500 text-white px-3 py-3 rounded-md shadow-md mr-2"
                                >
                                  <img
                                    className="h-[25px] w-[25px]"
                                    src={require("../../Assets/Images/share-video.png")}
                                    alt="logo"
                                  ></img>
                                </button>
                              </div>
                            </>
                          )}
                        </div>

                        <div className="flex flex-row flex-wrap mt-4 ml-4">
                          {data?.fixtures[0].goals.map((goal, goalKey) => (
                            <>
                              <Link
                                className={`text-white text-2xl font-bold DrukWide p-4 mx-2 my-1 w-[140px] text-center
                                        ${
                                          keyLoop === goalKey
                                            ? "bg-[#FF1541]"
                                            : "bg-[#2b2b2b]"
                                        }`}
                                onClick={() => {
                                  setKeyLoop(goalKey);
                                  setGoal(goal.url);
                                }}
                              >
                                {goal.home} - {goal.away}
                              </Link>
                            </>
                          ))}
                        </div>

                        <h4 className="text-white text-xl font-bold DrukWide mt-4 ml-4">
                          Game highlights
                        </h4>
                        <div className="relative mt-4 ml-4">
                          <video
                            // src={data?.fixtures[0].long_highlights_video}
                            className="w-full aspect-video"
                            allowFullScreen
                            controls
                            loop
                            muted
                          >
                            <source
                              src={data?.fixtures[0].long_highlights_video}
                              type="video/mp4"
                            />
                          </video>

                          <div className="absolute top-0 right-0 ">
                            <button
                              onClick={() =>
                                alert(data?.fixtures[0].long_highlights_video)
                              }
                              className="bg-gray-500 text-white px-3 py-3 rounded-md shadow-md mt-2"
                            >
                              <img
                                className="h-[25px] w-[25px]"
                                src={require("../../Assets/Images/download-video.png")}
                                alt="logo"
                              ></img>
                            </button>
                            <button
                              onClick={() =>
                                alert(data?.fixtures[0].long_highlights_video)
                              }
                              className="ml-2 bg-gray-500 text-white px-3 py-3 rounded-md shadow-md mr-2"
                            >
                              <img
                                className="h-[25px] w-[25px]"
                                src={require("../../Assets/Images/share-video.png")}
                                alt="logo"
                              ></img>
                            </button>
                          </div>
                        </div>
                      </div>
                      ) );
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    );
  }
}
